import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "editButton"]

  connect() {
    // Store original button content
    if (this.hasEditButtonTarget) {
      this.originalButtonContent = this.editButtonTarget.innerHTML
    }
  }

  toggleEdit() {    
    if (this.hasDisplayTarget && this.hasFormTarget && this.hasEditButtonTarget) {
      // Hide display, show form
      this.displayTarget.classList.add("hidden")
      this.formTarget.classList.remove("hidden")
      
      // Update button state
      this.editButtonTarget.innerHTML = `
        <svg class="w-4 h-4 inline-block mr-1 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
        </svg>
        Editando...
      `
      this.editButtonTarget.disabled = true
    }
  }

  cancelEdit() {
    
    if (this.hasDisplayTarget && this.hasFormTarget && this.hasEditButtonTarget) {
      // Show display, hide form
      this.formTarget.classList.add("hidden")
      this.displayTarget.classList.remove("hidden")
      
      // Reset button state to original
      this.editButtonTarget.innerHTML = this.originalButtonContent
      this.editButtonTarget.disabled = false
    }
  }
}